import * as React from "react"
import { useContext, useState } from "react"
import Slider from "react-slick"
import "../../slickslider.css"
import { Context } from "../../store/store"
import { getText } from "../strapi"
import MafoQuestionEight from "./Mafos/MafoQuestionEight"
import MafoQuestionFive from "./Mafos/MafoQuestionFive"
import MafoQuestionFour from "./Mafos/MafoQuestionFour"
import MafoQuestionNine from "./Mafos/MafoQuestionNine"
import MafoQuestionOne from "./Mafos/MafoQuestionOne"
import MafoQuestionSeven from "./Mafos/MafoQuestionSeven"
import MafoQuestionSix from "./Mafos/MAfoQuestionSix"
import MafoQuestionTen from "./Mafos/MafoQuestionTen"
import MafoQuestionThree from "./Mafos/MafoQuestionThree"
import MafoQuestionTwo from "./Mafos/MafoQuestionTwo"

interface MafoProps {
	formElementChanged: Function
	validation: Object
}
const Mafo: React.FC<MafoProps> = ({ formElementChanged, validation }) => {
	const { globalState } = useContext(Context)
	const [slider, setSlider] = useState<any>(null)
	const [arrowVisibilityPrev, setArrowVisbilityPrev] = useState(false)
	const [arrowVisibilityNext, setArrowVisbilityNext] = useState(true)

	const next = () => {
		slider?.slickNext()
	}
	var settings = {
		dots: true,
		infinite: false,
		speed: 100,
		slidesToShow: 1,
		arrows: false,
		slidesToScroll: 1,
		swipeToSlide: true,
		initialSlide: 0,
		adaptiveHeight: true,
		beforeChange: current => {
			switch (current) {
				case 0:
					setArrowVisbilityPrev(false)
					setArrowVisbilityNext(true)
					break
				case 8:
					setArrowVisbilityNext(false)
					// code block
					break
				default:
					setArrowVisbilityPrev(true)
					setArrowVisbilityNext(true)
			}
		},
	}

	return (
		<div className=" mx-auto mb-4 max-w-[500px] ">
			<h2 className="text-white mb-2">{getText(globalState.strapi.homepage.mafoHeadline, "mafoHeadline")}</h2>
			<p className="copy text-white pb-16">{getText(globalState.strapi.homepage.mafoCopy, "mafoCopy")}</p>
			<div className="rounded-xl bg-white py-12 max-w-[calc(100vw-2rem)]">
				<Slider ref={(c: any) => setSlider(c)} {...settings}>
					<div className="py-1 px-6">
						<MafoQuestionOne {...{ validation, formElementChanged }} />
					</div>
					<div className="py-4 px-6">
						<MafoQuestionTwo {...{ validation, formElementChanged }} />
					</div>
					<div className="py-1 px-6">
						<MafoQuestionThree {...{ validation, formElementChanged }} />
					</div>
					<div className="py-1 px-6">
						<MafoQuestionFour {...{ validation, formElementChanged }} />
					</div>
					<div className="py-1 px-6">
						<MafoQuestionFive {...{ validation, formElementChanged }} />
					</div>
					<div className="py-1 px-6">
						<MafoQuestionSix {...{ validation, formElementChanged }} />
					</div>
					<div className="py-1 px-6">
						<MafoQuestionSeven {...{ validation, formElementChanged }} />
					</div>
					<div className="py-1 px-6">
						<MafoQuestionEight {...{ validation, formElementChanged }} />
					</div>
					<div className="py-1 px-6">
						<MafoQuestionNine {...{ validation, formElementChanged }} />
					</div>
					<div className="py-1 px-6">
						<MafoQuestionTen {...{ validation, formElementChanged }} />
					</div>
				</Slider>
				<div className="mx-auto mt-12 text-center px-6 text-[22px] lg:text-[32px]">
					{arrowVisibilityNext && (
						<a
							className="btn-greenBG w-[140px] max-w-[65%] justify-self-end font-Veener text-white"
							onClick={() => {
								next()
							}}
						>
							Weiter
						</a>
					)}
				</div>
			</div>
			<div className="mb-12 lg:mb-12">
				{validation["invalid_question1"] ? (
					<p className="mx-auto  mb-6 mt-6 max-w-[80%] rounded-[5px] bg-white py-2 text-center  text-errorred lg:max-w-[50%]">Bitte Frage 1 beantworten.</p>
				) : (
					""
				)}
				{validation["invalid_question2"] ? (
					<p className="mx-auto mb-6 mt-6 max-w-[80%] rounded-[5px] bg-white py-2 text-center  text-errorred lg:max-w-[50%]">Bitte Frage 2 beantworten.</p>
				) : (
					""
				)}
			</div>
		</div>
	)
}

export default Mafo
